import { cx, Icon } from "@app/ui";
import { useT, type MessageKey } from "../i18n.js";

/**
 * Live password-policy feedback. Mirrors passwordSchema in @app/core (the API
 * enforces the same rules), so users see what's missing before submitting.
 */
const RULES: Array<{ key: MessageKey; test: (v: string) => boolean }> = [
  { key: "login.pwdRule.length", test: (v) => v.length >= 12 },
  { key: "login.pwdRule.lower", test: (v) => /[a-z]/.test(v) },
  { key: "login.pwdRule.upper", test: (v) => /[A-Z]/.test(v) },
  { key: "login.pwdRule.digit", test: (v) => /[0-9]/.test(v) },
  { key: "login.pwdRule.symbol", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export function passwordMeetsPolicy(value: string): boolean {
  return RULES.every((r) => r.test(value));
}

export function PasswordChecklist({ value }: { value: string }) {
  const t = useT();
  return (
    <ul className="auth-checklist" aria-live="polite">
      {RULES.map((r) => {
        const met = r.test(value);
        return (
          <li key={r.key} className={cx(met && "met")}>
            <Icon name={met ? "check" : "minus"} size={12} />
            <span>{t(r.key)}</span>
          </li>
        );
      })}
    </ul>
  );
}
